module.exports = __webpack_public_path__ + "img/Group 871.d549f2eb.svg";